import { render } from "./CInputPassword.vue?vue&type=template&id=30d72900"
import script from "./CInputPassword.vue?vue&type=script&lang=js"
export * from "./CInputPassword.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__